import { fetchAllBlogPosts } from './BlogPost';

// Function to get all blog posts for the list
export const getRelatedBlogs = async () => {
    try {
        console.log('getRelatedBlogs: Starting...'); // Debug log
        const posts = await fetchAllBlogPosts();
        console.log('getRelatedBlogs: Raw posts from API:', posts); // Debug log
        
        if (!posts || posts.length === 0) {
            console.log('getRelatedBlogs: No posts returned from API'); // Debug log
            return [];
        }
        
        const transformedPosts = posts.map((post, index) => {
            console.log(`getRelatedBlogs: Processing post ${index}:`, post); // Debug log
            return {
                image: post.image,
                date: post.date,
                designation: post.author,
                category: post.category,
                title: post.title,
                description: post.description,
                index: index,
                slug: post.slug,
                content: post.content
            };
        });
        
        console.log('getRelatedBlogs: Transformed posts:', transformedPosts); // Debug log
        return transformedPosts;
    } catch (error) {
        console.error('getRelatedBlogs: Error getting related blogs:', error);
        return [];
    }
};

// For backward compatibility, export an empty array
export const RelatedBlogs = [];
